
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule, ServiceResponseModule } from '@sdbn/common';

import { CommonTranslationModule } from '@sdbn/common';
import { TMCTableModule } from '@sdbn/common';
import { TransportWeighingsComponent } from './transport-weighings.component';

@NgModule({
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    TMCTableModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule
  ],
  declarations: [
    TransportWeighingsComponent
  ]
})
export class TransportWeighingsModule { }
